export const DistributorConnectionStatuses = {
  Connected: "connected",
  NotConnected: "not_connected",
} as const;

export type DistributorConnectionStatus =
  (typeof DistributorConnectionStatuses)[keyof typeof DistributorConnectionStatuses];

export const DistributorConnectionLabels: Record<
  DistributorConnectionStatus,
  string
> = {
  [DistributorConnectionStatuses.Connected]: "Connected",
  [DistributorConnectionStatuses.NotConnected]: "Not Connected",
};

export const DistributorConnectionOptions = Object.values(
  DistributorConnectionStatuses,
);
